import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectLoginResult } from '@auth0/auth0-spa-js';
import {
  AppStateService,
  IUserProfile,
  LoginSource,
  ProfileService,
  SessionService,
  StorageService,
} from '@services';
import { Logger } from '@utils/logger';
import { userInfo } from 'os';

const logger = Logger.getLogger('Auth0LoginCallbackComponent');

@Component({
  selector: 'ft-auth0-login-callback',
  templateUrl: './auth0-login-callback.component.html',
  styleUrls: ['./auth0-login-callback.component.scss'],
})
export class Auth0LoginCallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private sessionService: SessionService,
    private storageService: StorageService,
    private appStateService: AppStateService,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    // TODO handle connection error
    // TODO handle wrong username/password error
    this.sessionService.getAuth0Client()?.then((auth0Client) => {
      auth0Client
        ?.handleRedirectCallback()
        .then((loginResult: RedirectLoginResult<any>) => {
          logger.debug(loginResult);
          // need to set profile and navigate to appropriate page.
          Promise.all([
            auth0Client.getTokenSilently(),
            auth0Client.getUser(),
            auth0Client.getIdTokenClaims(),
          ]).then(([token, profile, claims]) => {
            logger.debug('logged in', token, profile, claims);
            this.profileService.initiateValidateSession(7000);
            this.storageService
              .getAuth0CallbackRoute()
              .then((route) => {
                if (route) {
                  this.router.navigate([route]);
                } else {
                  this.router.navigate([this.appStateService.getHomePageUrl]);
                }
              })
              .catch(() => {
                this.router.navigate([this.appStateService.getHomePageUrl]);
              });
          });
        })
        .catch((e) => {
          // FIXME handle login error
          alert('login failed');
        });
    });
  }
}
